import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import axios from 'axios';

import {
    responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, charactersRemainingGet, isUndNullEmp, languageObjGet, iconsGet,
    statusGet, textByNumericStatus, awaitDelay
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { informativeBillboardModelGet } from '../../models/informativeBillboard/informativeBillboard';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { userModelGet } from '../../models/users/user';

const currentMethod = 'InformativeBillboardAddEdit';

const { app, icons, images, labels, messages, react: reactSett, } = globalSettings;
const { backend, } = app;

export default function InformativeBillboardAddEdit({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
    $ = {},
    auth = {},
    processValue = {
        dtId: '',
        dtRowIndex: 0,
        icons: iconsGet({ languageId: languageObj?.id, subMethod: currentMethod, }),
        processType: 0,
        status: statusGet({ languageId: languageObj?.id, subMethod: currentMethod, }),
        titleTypes: textByNumericStatus({ languageId: languageObj?.id, subMethod: currentMethod, }),
        user: userModelGet({}),
        apartmentUsers: [apartmentUserModelGet({})],
        userRole: '',
    },
    building = buildingModelGet({}),
    informativeBillboard = informativeBillboardModelGet({}),
    setInformativeBillboard = () => { },
    showModal = false,
    setShowModal = () => { },
    informativeBillboardsGetAsync = async ({ e = {}, processType_ = '', subMethod = '', }) => { },
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const titleMaxLengthLocal = 40;
    const commentMaxLength = 250;
    const statusCommentMaxLength = 100;
    //const inputTitleId = 'inputTitle';
    const imgInformativeBillboardId = 'imgInformativeBillboard';
    const [userFullNameError, setUserFullNameError] = useState('');
    const [apartmentIdError, setApartmentIdError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [iconError, setIconError] = useState('');
    const [commentError, setCommentError] = useState('');
    const [commentRemaining, setCommentRemaining] = useState('');
    const [isEditDelete, setIsEditDelete] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(false);
    const [statusCommentError, setStatusCommentError] = useState('');
    const [statusCommentRemaining, setStatusCommentRemaining] = useState('');
    const [statusCommentShow, setStatusCommentShow] = useState(false);
    const [informativeBillboardBefore, setInformativeBillboardBefore] = useState({});
    const controls = {
        buttons: {
            save: {
                id: 'btnModalInformativeBillboardCreate',
                className: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnModalInformativeBillboardBack',
                className: '',
            },
            close: {
                id: 'btnModalInformativeBillboardClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            // informativeBillboard: {
            //     buttons: {
            //         create: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btnDtCondominiumBoardElectionsCreate',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btnDtCondominiumBoardElectionsDelete',
            //         },
            //     },
            //     icons: {
            //         create: {
            //             id: 'iconDtCondominiumBoardElectionsCreate',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'iconDtCondominiumBoardElectionsDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtInformativeBillboardId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtInformativeBillboardId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         create: {
            //             id: 'spDtCondominiumBoardElectionsCreate',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spDtCondominiumBoardElectionsDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoModalInformativeBillboardSave',
                className: icons?.save,
            },
            back: {
                id: 'icoModalInformativeBillboardBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoModalInformativeBillboardClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            user: {
                id: 'inputModalInformativeBillboardUser',
                className: 'form-control',
            },
            title: {
                id: 'inputModalInformativeBillboardTitle',
                className: 'form-control',
            },
            comment: {
                id: 'inputModalInformativeBillboardComment',
                className: 'form-control',
            },
            statusComment: {
                id: 'inputModalInformativeBillboardStatusComment',
                className: 'form-control text-black',
            },
        },
        selects: {
            apartment: {
                id: 'selModalInformativeBillboardApartmet',
                className: 'form-select',
            },
            title: {
                id: 'selModalInformativeBillboardTitle',
                className: 'form-select',
            },
            icon: {
                id: 'selModalInformativeBillboardIcon',
                className: 'form-select',
            },
            status: {
                id: 'selModalInformativeBillboardStatus',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalInformativeBillboardSave',
                className: '',
            },
            back: {
                id: 'spModalInformativeBillboardBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region set if is or not commont user
            setIsChangeStatus(building?.process?.edit || false);
            //#endregion set if is or not commont user

            //#region set status comment (show)
            setStatusCommentShow(
                !isUndNullEmp({ data: informativeBillboard?.status, subMethod: currentMethod, })?.result && informativeBillboard?.status > 1 ? true : false
            );
            //#endregion set status comment (show)

            //#region set informative billboard before
            setInformativeBillboardBefore(informativeBillboard);
            //#endregion set informative billboard before

            //#region set title color
            if (!isUndNullEmp({ data: informativeBillboard?.type, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: processValue?.titleTypes, subMethod: currentMethod, })?.result && processValue?.titleTypes?.length > 0) {
                response = await titleColorSetAsync({
                    e: {},
                    typeId: `${informativeBillboard?.type}`,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
                }
            }
            //#endregion set title color

            //#region set comment remaining
            setCommentRemaining(
                charactersRemainingGet({
                    text: !isUndNullEmp({ data: informativeBillboard?.comment, subMethod: currentMethod, })?.result ? informativeBillboard?.comment : '',
                    maxLength: commentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set comment remaining

            //#region set status comment remaining
            setStatusCommentRemaining(
                charactersRemainingGet({
                    text: !isUndNullEmp({ data: informativeBillboard?.statusComment, subMethod: currentMethod, })?.result ? informativeBillboard?.statusComment : '',
                    maxLength: statusCommentMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                }).result
            );
            //#endregion set status comment remaining

            //#region set is edit / delete
            const isEdit = processValue?.processType !== 0 ? informativeBillboard?.process?.edit || false : false;
            const isDelete = processValue?.processType !== 0 ? informativeBillboard?.process?.delete || false : false;
            //setIsEditDelete(!(localIsEdit && localIsDelete));
            setIsEditDelete((isEdit && isDelete));
            //#endregion set is edit / delete
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            defaultValueSetAsync(true);
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            await errosDefaultSetAsync({ subMethod: currentMethod, });

            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', isTitle = false, subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            //#region data set
            if (property === 'status' && parseInt(value) < 2) {
                setInformativeBillboard(
                    {
                        ...informativeBillboard,
                        [property]: (property === 'status' ? parseInt(value) : value),
                        statusComment: '',
                    }
                );
            } else {
                setInformativeBillboard({ ...informativeBillboard, [property]: (property === 'status' ? parseInt(value) : value), });
            }
            //#endregion data set

            //#region set status comment (show)
            if (property === 'status') {
                setStatusCommentShow(parseInt(value) > 1 ? true : false);
            }
            //#endregion set status comment (show)

            //#region set comment remaining
            if (property === 'comment') {
                setCommentRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: commentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set comment remaining

            //#region set status comment remaining
            if (property === 'statusComment') {
                setStatusCommentRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: statusCommentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set status comment remaining
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: informativeBillboard?.apartmentId, subMethod: currentMethod, })?.result) {
                setApartmentIdError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: informativeBillboard?.title, subMethod: currentMethod, })?.result) {
                setTitleError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: informativeBillboard?.type, subMethod: currentMethod, })?.result) {
                setTypeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: informativeBillboard?.iconName, subMethod: currentMethod, })?.result) {
                setIconError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: informativeBillboard?.comment, subMethod: currentMethod, })?.result) {
                setCommentError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (informativeBillboard?.comment?.length > commentMaxLength) {
                setCommentError(`${messages?.allowedCharacters?.[languageObj?.id]}: ${statusCommentMaxLength}`);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: informativeBillboard?.status, subMethod: currentMethod, })?.result && informativeBillboard?.status > 1) {
                if (isUndNullEmp({ data: informativeBillboard?.statusComment, subMethod: currentMethod, })?.result) {
                    setStatusCommentError(messages?.thisFieldRequired?.[languageObj?.id]);
                    response.isWarning = true;
                } else if (informativeBillboard?.statusComment?.length > statusCommentMaxLength) {
                    setStatusCommentError(`${messages?.allowedCharacters?.[languageObj?.id]}: ${statusCommentMaxLength}`);
                    response.isWarning = true;
                }
            }

            if (!isUndNullEmp({ data: informativeBillboard?.status, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: informativeBillboardBefore?.status, subMethod: currentMethod, })?.result &&
                !response?.isWarning && informativeBillboard?.status !== informativeBillboardBefore?.status) {
                informativeBillboard.statusUserId = auth?.user?.uid;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setUserFullNameError('');
            setApartmentIdError('');
            setTitleError('');
            setTypeError('');
            setIconError('');
            setCommentError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const informativeBillboardAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'informativeBillboardAddPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response
            };

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response
            };
            //#endregion initialize

            if (processValue?.processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });

                //#region data save
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    informativeBillboard: informativeBillboard,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion data save

                //#region informative billboard get data
                response = await informativeBillboardsGetAsync({
                    e: undefined,
                    processType_: informativeBillboard?.buildingId,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion informative billboard get data

                await defaultValueSetAsync({ isModalClose: true, subMethod: '', });

                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const informativeBillboardEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'informativeBillboardEditPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response
            };

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response
            };
            //#endregion initialize

            if (processValue?.processType === 1) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });

                //#region data save
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    informativeBillboard: informativeBillboard,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/${informativeBillboard?.id}`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion data save

                //#region informative billboard get
                response = await informativeBillboardsGetAsync({
                    e: undefined,
                    processType_: informativeBillboard?.buildingId,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion informative billboard get

                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const titleColorSetAsync = async ({ e = {}, typeId = '0', subMethod = '', }) => {
        const currentMethod = 'titleColorSetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e.preventDefault();
            }
            //#region variables
            const idLocal = !isUndNullEmp({ data: e, subMethod: currentMethod, })?.result ? e?.target?.value : typeId;
            let textClass = 'form-control';
            const inputObj = $(`#${controls?.inputs?.title?.id}`);
            let textClassObj = {};
            //#endregion variables

            if (!isUndNullEmp({ data: idLocal, subMethod: currentMethod, })?.result) {
                textClassObj = processValue?.titleTypes?.find(({ id }) => id === idLocal);
                inputObj?.attr('class', `${textClass} ${textClassObj?.type}`);
                inputObj?.val(`${inputObj?.val()} `);
                await formDataSetAsync({
                    property: 'type',
                    value: parseInt(idLocal),
                    isTitle: false,
                    subMethod: currentMethod,
                });
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const imageSetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'imageSetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();
            //#region variables
            //#region old code
            //const objInput?.iconName = e?.target?.value;
            //let objInput?.iconPath = '';
            //const objInput?.obj = $(`#${imgInformativeBillboardId}`);
            //let objInputs?.textClass;
            //#endregion old code
            const objInput = {
                obj: $(`#${imgInformativeBillboardId}`),
                textClass: '',
                iconPath: '',
                iconName: e?.target?.value,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: objInput?.iconName, subMethod: currentMethod, })?.result) {
                objInput.textClass = processValue?.icons?.find(({ name, }) => name === objInput?.iconName);
                objInput.iconPath = `${images?.urlImages}/${objInput?.textClass.name}`;
                objInput?.obj.attr({ src: objInput?.iconPath, });
            } else {
                objInput?.obj.attr({ src: images?.noImageLogo, });
            }
            setInformativeBillboard({ ...informativeBillboard, iconName: `${objInput?.iconName}`, iconPath: objInput?.iconPath, });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.user?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.apartment?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.title?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.title?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.icon?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.comment?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.status?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.statusComment?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactSett?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.applicants?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.applicants?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, [auth]) // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - form', })}>
            <Modal.Header>
                {/* <Modal.Title>{processValue?.processType === 0 ? labels?.add?.[languageObj?.id] : (processValue?.processType === 1 ? labels?.edit?.[languageObj?.id] : labels?.detail?.[languageObj?.id])}</Modal.Title> */}
                <Modal.Title>
                    <img alt='campaign'
                        src={images?.campaign}
                        style={styles?.cardHeaderLogo}></img> - {labels?.publication?.[languageObj?.id]} ({processValue?.processType === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValue?.processType === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    //className='close btn-danger fas fa-window-close'
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btnClose - modal', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValue?.processType === 0 ?
                informativeBillboardAddPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                (processValue?.processType === 1 ?
                    informativeBillboardEditPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                    e?.preventDefault())}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}

                    {/* <div className='card-header'>
                                <h6 className='card-title'><img alt='coins' src={images?.campaign} style={styles?.cardHeaderLogo}></img> - {labels?.publication?.[languageObj?.id]}</h6>
                            </div> */}

                    {/* <div className='card-body'> */}
                    {processValue?.processType !== 2 ?
                        <div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.user?.id}
                                                className={controls?.inputs?.user?.className}
                                                placeholder={labels?.user?.[languageObj?.id]}
                                                readOnly
                                                tooltip='tooltip'
                                                title={labels?.user?.[languageObj?.id]}
                                                value={`${processValue?.user?.firstName || ''}, ${processValue?.user?.lastName || ''}`} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.user} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(userFullNameError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.apartment?.id}
                                                className={controls?.selects?.apartment?.className}
                                                //autoFocus
                                                defaultValue={informativeBillboard?.apartmentId || ''}
                                                onChange={(e) => formDataSetAsync({ property: 'apartmentId', value: e?.target?.value, isTitle: false, subMethod: 'sel - apartmentId', })}
                                                onFocus={() => setApartmentIdError('')}
                                                placeholder={labels?.apartment?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.apartment?.[languageObj?.id]}>
                                                <option key='' value=''>{messages?.selectApartment?.[languageObj?.id]}</option>
                                                {processValue?.apartmentUsers?.map((detail) => (<option key={detail?.id} value={detail?.apartmentId}>{detail?.apartment?.identifier}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.houseUser} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(apartmentIdError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.title?.id}
                                                className={controls?.inputs?.title?.className}
                                                maxLength={titleMaxLengthLocal}
                                                onChange={(e) => formDataSetAsync({ property: 'title', value: e?.target?.value, isTitle: false, subMethod: 'input - title', })}
                                                onFocus={() => setTitleError('')}
                                                placeholder={labels?.title?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.title?.[languageObj?.id]}
                                                value={informativeBillboard?.title || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.textHeight} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(titleError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.title?.id}
                                                className={controls?.selects?.title?.className}
                                                defaultValue={`${informativeBillboard?.type || 0}`}
                                                onChange={(e) => titleColorSetAsync({ e: e, typeId: '0', subMethod: 'sel - titleType', })}
                                                onFocus={() => setTypeError('')}
                                                placeholder={labels?.type?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.type?.[languageObj?.id]}>
                                                {processValue?.titleTypes?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.houseUser} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(typeError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='form-group text-center'>
                                        <img id={imgInformativeBillboardId}
                                            src={!isUndNullEmp({ data: informativeBillboard?.iconName, subMethod: 'img - iconName', })?.result ? `${images?.urlImages}/${informativeBillboard?.iconName}` : images?.noImageLogo}
                                            alt='informativeBillboardIcon'
                                            className='img-circle img-fluid'
                                            style={{ height: '45px', width: '45px', objectFit: 'cover', }} />
                                    </div>
                                </div>
                                <div className='col-md-8'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.icon?.id}
                                                className={controls?.selects?.icon?.className}
                                                defaultValue={informativeBillboard?.iconName || images?.noImageLogo}
                                                onChange={(e) => imageSetAsync({ e: e, subMethod: 'sel - iconName', })}
                                                onFocus={(e) => setIconError('')}
                                                placeholder={labels?.icon?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.icon?.[languageObj?.id]}>
                                                <option key='' value=''>{messages?.selectIcon?.[languageObj?.id]}</option>
                                                {processValue?.icons?.map((detail) => (<option key={detail?.id} value={detail?.name}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.icons} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(iconError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.comment?.id}
                                                className={controls?.inputs?.comment?.className}
                                                maxLength={commentMaxLength}
                                                onChange={(e) => formDataSetAsync({ property: 'comment', value: e?.target?.value, isTitle: false, subMethod: 'textArea - comment', })}
                                                onFocus={() => setCommentError('')}
                                                placeholder={labels?.comment?.[languageObj?.id]}
                                                rows={3}
                                                tooltip='tooltip'
                                                title={labels?.comment?.[languageObj?.id]}
                                                value={informativeBillboard?.comment || ''}>
                                            </textarea>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.edit} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(commentRemaining)}</div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(commentError)}</div>
                                    </div>
                                </div>
                            </div>

                            {processValue?.processType === 1 ?
                                <div>
                                    {isChangeStatus || statusCommentShow ?
                                        <div className='row'>
                                            <div className='col-md-4 text-muted'>
                                                <b>{labels?.status?.[languageObj?.id]}</b>
                                            </div>
                                            <div className='col-md-8'>
                                                <hr />
                                            </div>
                                        </div>
                                        :
                                        <></>
                                    }

                                    {isChangeStatus ?
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <select id={controls?.selects?.status?.id}
                                                            className={controls?.selects?.status?.className}
                                                            defaultValue={`${informativeBillboard?.status || 0}`}
                                                            disabled={!isEditDelete}
                                                            onChange={(e) => formDataSetAsync({ property: 'status', value: e?.target?.value, isTitle: false, subMethod: 'sel - status', })}
                                                            onFocus={() => setTypeError('')}
                                                            placeholder={labels?.status?.[languageObj?.id]}
                                                            tooltip='tooltip'
                                                            title={labels?.status?.[languageObj?.id]}>
                                                            {processValue?.status?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                                        </select>
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.houseUser} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(typeError)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                    }

                                    {statusCommentShow ?
                                        <div>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <textarea id={controls?.inputs?.statusComment?.id}
                                                                className={controls?.inputs?.statusComment?.className}
                                                                //disabled={!isEditDelete}
                                                                maxLength={commentMaxLength}
                                                                onChange={(e) => formDataSetAsync({ property: 'statusComment', value: e?.target?.value, isTitle: false, subMethod: 'textArea - statusComment', })}
                                                                onFocus={() => setStatusCommentError('')}
                                                                placeholder={labels?.comment?.[languageObj?.id]}
                                                                readOnly={!isChangeStatus}
                                                                rows={3}
                                                                tooltip='tooltip'
                                                                title={labels?.comment?.[languageObj?.id]}
                                                                value={informativeBillboard?.statusComment || ''}>
                                                            </textarea>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.edit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(statusCommentRemaining)}</div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(statusCommentError)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : <></>
                                    }
                                </div>
                                :
                                <></>
                            }
                        </div>
                        :
                        <div className='d-flex align-items-stretch flex-column'>
                            <div className='card bg-light d-flex flex-fill'>
                                <div className='card-header text-muted border-bottom-0'>
                                    <img src={informativeBillboard?.iconPath} alt={informativeBillboard?.iconName} className='img-circle img-fluid' height='30px' width='30px' />
                                    <span className={processValue?.titleTypes?.filter(({ id, }) => id === `${informativeBillboard?.type}`)?.[0]?.type}> {informativeBillboard?.title}</span>
                                </div>
                                <div className='card-body pt-0'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <ul className='ml-4 mb-0 fa-ul text-muted'>
                                                <li className='small'><span className='fa-li'><i className={icons?.user}></i></span> {labels?.user?.[languageObj?.id]}: <b>{informativeBillboard?.user?.firstName}, {informativeBillboard?.user?.lastName}</b></li>
                                                <li className='small'><span className='fa-li'><i className={icons?.houseUser}></i></span> {labels?.apartment?.[languageObj?.id]}: <b>{informativeBillboard?.apartment?.identifier}</b></li>
                                                <li className='small'><span className='fa-li'><i className={icons?.calendarAlt}></i></span> {labels?.created?.[languageObj?.id]}: <b>{dateTimeFormatGlobalSet({
                                                    date: informativeBillboard?.created || new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: languageObj?.format?.time?.type,
                                                    addTime: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result}</b></li>
                                                <li className='small'><span className='fa-li'><i className={icons?.bullhorn}></i></span> {labels?.comment?.[languageObj?.id]}: <b>{informativeBillboard?.comment || ''}</b></li>
                                            </ul>
                                            {/* <p className='text-muted text-sm pt-2'>{informativeBillboard?.comment || ''}</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {processValue?.processType === 0 || processValue?.processType === 1 ?
                                    <button className='btn btn-outline-warning mx-1'
                                        onClick={(e) => processValue?.processType === 0 ? informativeBillboardAddPostAsync(e) : (processValue?.processType === 1 ? informativeBillboardEditPostAsync(e) : null)}
                                        tooltip='tooltip'
                                        title={processValue?.processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button> : <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btn - modal-footer' })}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        {processValue?.processType === 0 || processValue?.processType === 1 ?
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                //onClick={(e) => processValue?.processType === 0 ? informativeBillboardAddPostAsync({ e: e, subMethod: 'form - fotterBtnSave', }) : (processValue?.processType === 1 ? informativeBillboardEditPostAsync({e: e, subMethod: 'form - onSubmit',}) : e?.preventDefault())}
                                tooltip='tooltip'
                                title={processValue?.processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className={controls?.spinners?.save?.className} aria-hidden={true}></span>
                            </button> : <></>
                        }
                        <button className='btn btn-outline-success'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'btn - modal-footer' })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className={controls?.spinners?.back?.className} aria-hidden={true}></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}